<template>
    <div class="card course-item border-0 font-weight-bold position-relative"
        :class="classes"
    >
        <div class="card-body">
            <template v-if="course.visual">
                <CourseVisual
                    :course="course"
                    style="margin-bottom: .5em"
                />
            </template>

            <template v-if="course.is_qualiopi">
                <div class="d-flex mb-2">
                    <div class="bg-primary text-white px-1"
                        :class="course.theme === 'event' ? 'bg-white text-primary' : 'bg-primary text-white'"
                    >
                        formation
                    </div>
                </div>
            </template>

            <template v-if="course.partner">
                <div style="margin-bottom: .375em">
                    <div class="course-item__partner d-flex flex-column mb-n1">
                        <template v-if="course.partner.thumbnail">
                            <img
                                class="course-item__partner-image flex-fill align-self-start mb-1"
                                style="min-height: 0"
                                :src="course.partner.thumbnail"
                                :alt="course.partner.legend || 'partenaire'"
                            >
                        </template>
                        <template v-if="course.partner.legend">
                            <div class="mb-1 course-item__partner-legend" v-html="course.partner.legend">
                            </div>
                        </template>
                    </div>
                </div>
                <template v-if="course.surtitle">
                    <hr style="margin-top: .5em">
                </template>
            </template>

            <template v-if="course.surtitle">
                <div class="course__surtitle mb-2">
                    {{ course.surtitle }}
                </div>
            </template>

            <h3 class="course-item__title p-2 pb-3">
                <template v-if="hasLink">
                    <router-link :to="courseRouteUrl($router, course)" custom v-slot="{ href, navigate }">
                        <a :href="href" class="stretched-link" style="color:inherit" @click="navigate">
                            {{ course.title }}
                        </a>
                    </router-link>
                </template>
               <template v-else>
                   {{ course.title }}
               </template>
            </h3>

            <div class="mb-1">
                <div class="course-item__date">
                    {{ course.date_label }}
                </div>
            </div>

            <template v-if="course.place_label">
                <hr>
                <div>
                    <div class="course-item__place">
                        <CustomText :content="course.place_label" />
                    </div>
                </div>
            </template>

            <template v-if="showTag">
                <div style="margin-top: .75em">
                    <div class="row mx-n1 mb-n2">
                        <div class="col-auto px-1 mb-2">
                            <slot name="tag">
                                <CourseTag :course="course" />
                            </slot>
                        </div>
                        <div class="col-auto px-1 mb-2">
                            <div class="course-item__icons">
                                <div class="row flex-nowrap mx-n1">
                                    <div class="col-auto px-1">
                                        <template v-if="course.is_free">
                                            <Icon name="details-free" width="1.25em" height="1.25em" />
                                        </template>
                                        <template v-else>
                                            <Icon name="details-euro" width="1.25em" height="1.25em" />
                                        </template>
                                    </div>
                                    <template v-if="course.has_remote_sessions">
                                        <div class="col-auto px-1">
                                            <Icon name="details-video" width="1.25em" height="1.25em" />
                                        </div>
                                    </template>
                                    <template v-if="course.has_onsite_sessions">
                                        <div class="col-auto px-1">
                                            <Icon name="details-on-site" width="1.25em" height="1.25em" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <template v-if="$slots.footer">
            <div class="card-footer bg-white border-0">
                <slot name="footer" />
            </div>
        </template>
    </div>
</template>

<script>
  import CourseTag from "./ui/CourseTag";
  import CustomText from "./ui/CustomText";
  import Icon from "./ui/Icon";
  import CourseVisual from "./CourseVisual";
  import { baseUrl } from "../util/config";
  import { courseRouteUrl } from "../util/url";

  export default {
        components: {
            CourseVisual,
            Icon,
            CustomText,
            CourseTag
        },
        props: {
            course: Object,
            showTag: {
                type: Boolean,
                default: true,
            }
        },
        computed: {
            classes() {
                return {
                    'course-item--dark': this.course.theme === 'event',
                    'course-item--link': this.hasLink,
                }
            },
            hasLink() {
                return this.$router && !this.course.without_show_page;
            },
        },
        methods: {
            baseUrl,
            courseRouteUrl,
        },
    }
</script>
